import { SessionOccurrenceResponse } from "../contracts/SessionOccurrenceResponse";
import { SessionOccurrence } from "../models/SessionOccurrence";

export class OccurrenceResponseMapper {
  /**
   * Converts a SessionOccurrenceResponse to a SessionOccurrence model,
   * trimming the wire time (HH:mm:ss) to the UI's HH:mm shape.
   */
  toOccurrence = (resp: SessionOccurrenceResponse): SessionOccurrence => {
    return {
      originalDate: resp.originalDate,
      effectiveDate: resp.effectiveDate,
      effectiveTime: resp.effectiveTime.split(":").slice(0, 2).join(":"),
      status: resp.status,
      reason: resp.reason,
      cancelledAt: resp.cancelledAt,
      cancelledBy: resp.cancelledBy,
      visitCount: resp.visitCount,
      isFull: resp.isFull ?? false,
    };
  };

  toOccurrences = (responses: SessionOccurrenceResponse[]): SessionOccurrence[] =>
    responses.map(this.toOccurrence);
}
